import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

const DEFAULT_ASIDE_WIDTH = 358;
const MIN_ASIDE_WIDTH = 280;
const MAX_ASIDE_WIDTH = 640;

function clamp(value: number, min: number, max: number) {
    return Math.max(min, Math.min(max, value));
}

type LayoutStore = {
    asideWidth: number;
    setAsideWidth: (width: number) => void;
    resetAsideWidth: () => void;
};

const initialState = {
    asideWidth: DEFAULT_ASIDE_WIDTH,
};

export const useLayoutStore = create<LayoutStore>()(
    devtools(
        persist(
            immer((set) => ({
                ...initialState,
                setAsideWidth: (width) =>
                    set((state) => {
                        state.asideWidth = clamp(width, MIN_ASIDE_WIDTH, MAX_ASIDE_WIDTH);
                    }),
                resetAsideWidth: () =>
                    set((state) => {
                        state.asideWidth = DEFAULT_ASIDE_WIDTH;
                    }),
            })),
            {
                name: "emns.aside-width",
                storage: createJSONStorage(() => localStorage),
                partialize: (state) => ({ asideWidth: state.asideWidth }),
            },
        ),
        { enabled: import.meta.env.VITE_ENVIRONMENT !== "prod", name: "Layout" },
    ),
);
